import { render, staticRenderFns } from "./LandingMobile.vue?vue&type=template&id=3695bb1e&scoped=true&"
import script from "./LandingMobile.vue?vue&type=script&lang=js&"
export * from "./LandingMobile.vue?vue&type=script&lang=js&"
import style0 from "./LandingMobile.vue?vue&type=style&index=0&id=3695bb1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3695bb1e",
  null
  
)

export default component.exports